import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Send, Sparkles } from "lucide-react";
import { assistantApi, getAssistantSession } from "../lib/api";

const clean = (t) => String(t).replace(/\*\*(.*?)\*\*/g, "$1").replace(/(^|\n)\s*[*-]\s+/g, "$1• ");

export default function AssistantPage() {
  const navigate = useNavigate();
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([{ role: "assistant", content: "¡Hola! Soy el Asistente Virtual de Supera. ¿En qué puedo ayudarte hoy?" }]);
  const sessionRef = useRef(getAssistantSession());
  const scrollRef = useRef(null);

  useEffect(() => { if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight; }, [messages, loading]);

  const send = async (e) => {
    e?.preventDefault();
    const text = input.trim();
    if (!text || loading) return;
    setInput("");
    setMessages((m) => [...m, { role: "user", content: text }]);
    setLoading(true);
    try {
      const { reply } = await assistantApi.chat(text, sessionRef.current);
      setMessages((m) => [...m, { role: "assistant", content: reply }]);
    } catch {
      setMessages((m) => [...m, { role: "assistant", content: "Lo siento, ocurrió un error. Intenta de nuevo." }]);
    } finally { setLoading(false); }
  };

  return (
    <div className="h-screen flex flex-col bg-[#FAF8F1]" data-testid="assistant-page">
      <header className="bg-navy flex-shrink-0">
        <div className="max-w-2xl mx-auto px-6 h-16 flex items-center gap-3">
          <button data-testid="assistant-back-btn" onClick={() => navigate("/chat")} className="text-white/70 hover:text-white transition-colors"><ArrowLeft className="w-5 h-5" /></button>
          <span className="w-9 h-9 rounded-xl bg-[var(--gold)] flex items-center justify-center"><Sparkles className="w-5 h-5 text-[#0A1C30]" /></span>
          <div><p className="font-extrabold text-white leading-tight">Asistente Virtual Supera</p><p className="text-xs text-white/60">Siempre disponible</p></div>
        </div>
      </header>
      <div ref={scrollRef} className="flex-1 overflow-y-auto supera-scroll">
        <div className="max-w-2xl mx-auto px-6 py-6 space-y-3">
          {messages.map((m, i) => (
            <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[85%] px-4 py-2.5 rounded-2xl text-sm leading-relaxed whitespace-pre-wrap ${m.role === "user" ? "bg-[#0A1C30] text-white rounded-br-md" : "bg-white text-[#2A3446] ring-1 ring-black/5 rounded-bl-md"}`}>
                {m.role === "assistant" ? clean(m.content) : m.content}
              </div>
            </div>
          ))}
          {loading && <div className="flex justify-start"><div className="bg-white ring-1 ring-black/5 rounded-2xl rounded-bl-md px-4 py-3"><span className="flex gap-1"><span className="w-2 h-2 rounded-full bg-[#B9C0CC] animate-bounce" /><span className="w-2 h-2 rounded-full bg-[#B9C0CC] animate-bounce" style={{ animationDelay: "150ms" }} /><span className="w-2 h-2 rounded-full bg-[#B9C0CC] animate-bounce" style={{ animationDelay: "300ms" }} /></span></div></div>}
        </div>
      </div>
      <form onSubmit={send} className="flex-shrink-0 border-t border-black/5 bg-white">
        <div className="max-w-2xl mx-auto px-4 py-3 flex items-center gap-2">
          <input data-testid="assistant-input" value={input} onChange={(e) => setInput(e.target.value)} placeholder="Escribe tu pregunta..." className="flex-1 h-11 px-4 rounded-full bg-[#F4F6F9] text-sm text-[#0A1C30] outline-none focus:ring-2 focus:ring-[var(--gold)]" />
          <button type="submit" disabled={loading || !input.trim()} className="w-11 h-11 rounded-full bg-[var(--gold)] hover:bg-[var(--gold-soft)] disabled:opacity-50 flex items-center justify-center transition-colors"><Send className="w-5 h-5 text-[#0A1C30]" /></button>
        </div>
      </form>
    </div>
  );
}
